import { render, staticRenderFns } from "./propertyDialog.vue?vue&type=template&id=4da2561e&scoped=true&"
import script from "./propertyDialog.vue?vue&type=script&lang=js&"
export * from "./propertyDialog.vue?vue&type=script&lang=js&"
import style0 from "./propertyDialog.vue?vue&type=style&index=0&id=4da2561e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da2561e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCardText,VTab,VTabItem,VTabs,VTabsItems})
